import React, { useEffect, useState } from 'react';
import { NoParamsFn } from 'tae/timesheets/types';
import { Dialog, ErrorButton } from '@beeline.com/bp-design-system';
import { JobFamily } from './jobFamily.graphql';
import { useJobFamiliesIntl } from './translations/useJobFamiliesIntl';

interface JobFamilyDeleteDialogProps {
  show: boolean;
  isLoading: boolean;
  onClose: NoParamsFn;
  onSubmit: NoParamsFn;
  jobFamilies: JobFamily[];
  workdayJobFamilies: JobFamily[];
  uids: string[];
  isBulkAction: boolean;
}

export const JobFamilyDeleteDialog: React.FC<React.PropsWithChildren<JobFamilyDeleteDialogProps>> = ({
  show,
  isLoading,
  onClose,
  onSubmit,
  jobFamilies,
  workdayJobFamilies,
  uids,
  isBulkAction
}) => {
  const intl = useJobFamiliesIntl();
  const [formName, setFormName] = useState('');

  useEffect(() => {
    setFormName(jobFamilies.map((jobFamily) => `"${jobFamily?.name ?? ''}"`).join(', '));
  }, [jobFamilies]);

  const resultMessage = isBulkAction
    ? intl.sureYouWantToDeleteJobFamilyWith({
        formName,
        totalCount: uids.length
      })
    : intl.sureYouWantToDeleteJobFamily;

  const workdayJobFamilyList = workdayJobFamilies.map((jobFamily) => <li key={jobFamily.uid}>{jobFamily.name}</li>);

  return (
    <Dialog
      open={show}
      onClose={onClose}
      dataTest="confirm-delete-job-families-dialog"
      title={intl.deleteJobFamily}
      subTitle={resultMessage}
      show={{ cancelButton: true }}
      disableBackdropClick
      actions={[
        <ErrorButton.Contained
          key="confirm-button"
          dataTest="job-family__confirm-delete-button"
          disabled={uids.length < 1}
          onClick={onSubmit}
          loading={isLoading}
        >
          {intl.confirmAndDelete}
        </ErrorButton.Contained>
      ]}
    >
      {workdayJobFamilyList.length > 0 && isBulkAction && (
        <>
          {intl.externalJobFamiliesCannotBeDeleted}
          <ul>{workdayJobFamilyList}</ul>
        </>
      )}
    </Dialog>
  );
};
